import { StatusCell } from "@/components/Evaluate/TableComponents/RowCell/CellTypes/StatusCell";
import { ColumnType } from "@/types/evaluate";
import { getCellType } from "./CellUtils";
import { getBooleanColors } from "./BooleanCell";
import { ScoreCell } from "./ScoreCell";
import { BaseCellWrapper } from "./BaseCellWrapper";
import { getCellValue } from "./utils";
import { ScoreCellActions } from "./ScoreCellActions";
import { ReportContext } from "@/components/Evaluate/report-context";
import { useContext } from "react";

interface CellProps {
  placeholder?: boolean;
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
}

export const TableCell = ({
  children,
  placeholder,
  className = "",
  reportColumn,
  isLastCell,
  isFirstCell,
  value,
}: CellProps) => {
  const status = value?.status?.toLowerCase();
  const isEval = useContext(ReportContext);

  const cellType = value ? getCellType(value?.display_value?.value) : null;
  const cellValue = getCellValue(value);

  if (
    reportColumn?.column_type !== ColumnType.COMPARE &&
    reportColumn?.column_type !== ColumnType.LLM_ASSERTION &&
    !(reportColumn?.column_type === ColumnType.HUMAN && status === "queued") &&
    (reportColumn?.is_part_of_score || isLastCell) &&
    status !== "failed" &&
    value
  ) {
    const isNotQueued =
      status !== "queued" || reportColumn?.column_type === ColumnType.HUMAN;

    const { isBoolean, isNumber } = cellType || {
      isBoolean: false,
      isNumber: false,
    };
    const booleanValue =
      cellValue === true ||
      (typeof cellValue === "string" && cellValue?.toLowerCase() === "true");

    return (
      <BaseCellWrapper
        className={`group relative ${
          isBoolean && isNotQueued ? getBooleanColors(booleanValue) : ""
        }`}
        isFirstCell={isFirstCell}
        isLastCell={isLastCell}
        placeholder={placeholder}
      >
        <div className="absolute right-2 top-2 z-10 flex justify-end overflow-visible p-1 opacity-0 transition-opacity duration-200 group-hover/Cell:opacity-100 ">
          {isEval && (
            <ScoreCellActions
              cell={value}
              cellValue={cellValue?.toString() || ""}
            />
          )}
        </div>
        {status === "queued" || status === "running" ? (
          <StatusCell status={status} />
        ) : (
          <ScoreCell
            isBoolean={isBoolean}
            isNumber={isNumber}
            booleanValue={booleanValue}
          >
            {cellValue}
          </ScoreCell>
        )}
      </BaseCellWrapper>
    );
  }

  return (
    <BaseCellWrapper
      className={className}
      isFirstCell={isFirstCell}
      isLastCell={isLastCell}
      placeholder={placeholder}
    >
      {children || (
        <div className="px-2">
          <div className="w-full break-words py-2 text-xs text-gray-700">
            {cellValue}
          </div>
        </div>
      )}
    </BaseCellWrapper>
  );
};
